import React, { useState, useEffect } from "react";
import i18n from "i18next";
import { Box } from "./FooterStyles";
import { useTranslation } from "react-i18next";
import "../Translation/i18n";

import { MDBFooter } from "mdb-react-ui-kit";
// Ref -> https://mdbootstrap.com/docs/react/navigation/footer/#docsTabsOverview
// Ref -> https://www.geeksforgeeks.org/how-to-create-a-simple-responsive-footer-in-react-js/
export default function Footer() {
  const { t } = useTranslation();

  const [directionState, setDirectionState] = useState("ltr");

  React.useEffect(() => {
    if (i18n.language.includes("en")) {
      setDirectionState("ltr");
    } else {
      setDirectionState("rtl");
    }

    console.log("i18n.locale: " + i18n.language);
  });

  return (
    <Box dir={directionState}>
      <MDBFooter bgColor="light" className="text-center text-lg-left">
        {i18n.language.includes("en") ? (
          <div
            className="text-center p-1"
            style={{
              backgroundColor: "#FFFFFF",
              color: "#049FDB",
              fontFamily: i18n.language.includes("en")
                ? "CI-Font-Body-Text"
                : "CI-Font-Body-Text-ar",
              textAlign: "center",
              paddingTop: 5,
              paddingBottom: 5,
              fontSize: 12,
            }}
          >
            {t("Copyright")} &copy; {new Date().getFullYear()}{" "}
            <label
              style={{
                color: "#049FDB",
                fontFamily: i18n.language.includes("en")
                  ? "CI-Font-Body-Text"
                  : "CI-Font-Body-Text-ar",
              }}
            >
              GB Capital {t("all_rights_reserved")}
            </label>
          </div>
        ) : (
          <div
            className="text-center p-1"
            style={{
              backgroundColor: "#FFFFFF",
              color: "#049FDB",
              fontFamily: i18n.language.includes("en")
                ? "CI-Font-Body-Text"
                : "CI-Font-Body-Text-ar",
              textAlign: "center",
              paddingTop: 5,
              paddingBottom: 5,
              fontSize: 12,
            }}
          >
            <label
              style={{
                color: "#049FDB",
                fontFamily: i18n.language.includes("en")
                  ? "CI-Font-Body-Text"
                  : "CI-Font-Body-Text-ar",
              }}
            >
              {t("all_rights_reserved")} GB Capital {t("Copyright")} &copy;{" "}
              {new Date().getFullYear()}{" "}
            </label>
          </div>
        )}
      </MDBFooter>
    </Box>
  );
}
